import { combineReducers } from 'redux';

import { SET_SOCIAL_CONNECTED, SET_LOOKUP_LOADING } from '../actions/lookup';

const socialConnected = (state = '', { type, payload }) => {
    let nextState = state;

    if (type === SET_SOCIAL_CONNECTED) {
        nextState = payload;
    }
    return nextState;
};

const lookupLoading = (state = false, { type, payload }) => {
    let nextState = state;

    if (type === SET_LOOKUP_LOADING) {
        nextState = payload;
    }
    return nextState;
};

export default combineReducers({
    socialConnected,
    lookupLoading,
});
